export const connectedWithTherapist = (state) => {
  return state.connectedWithTherapist
}

export const connectedWithTherapistToolTip = (state) => {
  return state.connectedWithTherapistToolTip
}


export const inApp = (state) => {
  return state.inApp
}

export const onboarding = (state) => {
  return state.onboarding
}


export const inactivated = (state) => {
  return state.inactivated
}

export const connectedWithTherapistInPeriod = (state) => {
  return state.connectedWithTherapistInPeriod
}

export const inAppInPeriod = (state) => {
  return state.inAppInPeriod
}

export const onboardingInPeriod = (state) => {
  return state.onboardingInPeriod
}

export const onboardingPendingInPeriod = (state) => {
  return state.onboardingPendingInPeriod
}

export const inactivatedInPeriod = (state) => {
  return state.inactivatedInPeriod
}

export const connectedWithTherapistEvent = (state) => {
  return state.connectedWithTherapistEvent
}

export const connectedWithTherapistEventSustain = (state) => {
  return state.connectedWithTherapistEventSustain
}

export const connectedWithTherapistEventGraduate = (state) => {
  return state.connectedWithTherapistEventGraduate
}

export const inAppEvent = (state) => {
  return state.inAppEvent
}

export const onboardingEvent = (state) => {
  return state.onboardingEvent
}

export const onboardingPendingEvent = (state) => {
  return state.onboardingPendingEvent
}

export const inactivatedEvent = (state) => {
  return state.inactivatedEvent
}

export const invitations = (state) => {
  return state.invitations
}

export const invitationsPeriod = (state) => {
  return state.invitationsPeriod
}

export const flyers = (state) => {
  return state.flyers
}

export const flyersPeriod = (state) => {
  return state.flyersPeriod
}

export const flyersUsed = (state) => {
  return state.flyersUsed
}

export const flyersUsedPeriod = (state) => {
  return state.flyersUsedPeriod
}

export const expiredInvitations = (state) => {
  return state.expiredInvitations
}

export const expiredInvitationsPeriod = (state) => {
  return state.expiredInvitationsPeriod
}

export const expiredFlyers = (state) => {
  return state.expiredFlyers
}

export const expiredFlyersPeriod = (state) => {
  return state.expiredFlyersPeriod
}

export const waist = (state) => {
  return state.waist
}

export const weight = (state) => {
  return state.weight
}

export const allDoctors = (state) => {
  return state.allDoctors
}
